import { ConsumptionInfo } from '../storageProvider';

export class CorruptedStorageValueError extends Error {}

export const load = (namespace: string): ConsumptionInfo | null => {
  const storageValue = localStorage.getItem(namespace);
  if (storageValue == null) return null;

  try {
    const info = JSON.parse(atob(storageValue));

    if ('consumedCount' in info && 'firstConsumedAt' in info && typeof info.consumedCount === 'number') {
      return info;
    }
  } catch (error) {}
  throw new CorruptedStorageValueError('CorruptedStorageValueError');
};

export const save = (namespace: string, info: ConsumptionInfo): void => {
  const storageValue = btoa(JSON.stringify(info));

  localStorage.setItem(namespace, storageValue);
};
